import { createContext } from 'react'
import { ResizableModel } from '../resizable-core/src'

export const ResizablePaneContext = createContext({} as ResizableModel)
